import React from "react";
import alratv_logo from "../Assests/alratv-logo.svg";

const Header = () => {
  return (
    <header className="bg-white py-4 px-6 md:px-12 flex items-center justify-center md:justify-center">
      <div className="flex items-center self-center justify-center gap-2">
        <img
          src={alratv_logo}
          alt="ALRA TV Logo"
          className=" md:h-[48px] sm:h-[36px] h-[36px] object-contain"
        />
      </div>
    </header>
  );
};

export default Header;
